import './search-input.less'
import { Input } from '@hose/eui'
import React, { Component } from 'react'
import classNames from 'classnames'

export default class SearchInput extends Component {
  state = { value: this.props.value || '', focus: false }

  componentWillReceiveProps(nextProps) {
    const lastValue = this.props.value
    const lastSearchClear = this.props.searchclear
    const nextValue = nextProps.value
    const nextSearchClear = nextProps.searchclear
    if (lastValue !== nextValue) {
      this.setState({ value: nextValue || '' })
    }
    if (lastSearchClear !== nextSearchClear) {
      this.handleClear()
    }
  }

  handleInputChange = e => {
    this.setState({ value: e.target.value })
    this.props.onChange && this.props.onChange(e)
  }

  handleFocusBlur = e => {
    this.setState({ focus: e.target === document.activeElement })
  }

  handleSearch = () => {
    if (this.props.onSearch) {
      this.props.onSearch(this.state.value)
    }
  }

  render() {
    const { style, className, onSearch, isShowClearIcon = true, menuSearch = false, noSearchIcon, ...restProps } = this.props
    const Search = noSearchIcon ? Input : Input.Search
    return (
      <div className={classNames('ekb-ele-search-input', className)} style={style}>
        <Search
          {...restProps}
          allowClear = {isShowClearIcon}
          value={this.state.value}
          onChange={this.handleInputChange}
          onFocus={this.handleFocusBlur}
          onBlur={this.handleFocusBlur}
          onPressEnter={this.handleSearch}
          onSearch={this.handleSearch}
        />
      </div>
    )
  }
}
